import { resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "main-content-container",
    "data-cy": "tenants-page"
};
const _hoisted_2 = { class: "row justify-content-between" };
const _hoisted_3 = { class: "col ml-3" };
const _hoisted_4 = {
    key: 0,
    class: "col-auto"
};
const _hoisted_5 = {
    key: 1,
    class: "col-auto"
};
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "row" };
const _hoisted_8 = { class: "col" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_acl = _resolveDirective("acl");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createVNode($setup["AddTenant"], {
            ref: "addTenant",
            access: $props.access,
            onUpdateTenants: $setup.allTenantsQuery.refetch
        }, null, 8, ["access", "onUpdateTenants"]), [
            [_directive_acl, $props.access, "privileged"]
        ]),
        _withDirectives(_createVNode($setup["EditTenant"], {
            ref: "editTenant",
            access: $props.access,
            onUpdateTenants: $setup.allTenantsQuery.refetch
        }, null, 8, ["access", "onUpdateTenants"]), [
            [_directive_acl, $props.access, "privileged"]
        ]),
        _createVNode($setup["BContainer"], { fluid: "" }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('JTADM_TENANTS_HEADER')), 1)
                    ]),
                    ($setup.allTenantsQuery.loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode($setup["Loading"])
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode($setup["BButton"], {
                                variant: "secondary",
                                onClick: $setup.addTenant?.showAddTenant
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode("+ " + _toDisplayString(_ctx.$t('JTADM_TENANTS_CREATE_TENANT')), 1)
                                ]),
                                _: 1
                            }, 8, ["onClick"])
                        ]))
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode($setup["Card"], {
                        "bg-color": "bg-aqua",
                        icon: "dripicons-user",
                        number: $setup.tenants.length,
                        text: _ctx.$t('JTADM_TENANTS_HEADER')
                    }, null, 8, ["number", "text"])
                ])), [
                    [_directive_acl, $props.access, "privileged"]
                ]),
                _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                _createVNode($setup["CommonSearchInput"], {
                    "model-value": $setup.searchQuery,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.searchQuery) = $event)),
                    "data-cy": "tenant-search",
                    placeholder: _ctx.$t('JTDAM_SEARCH_NAME'),
                    onRefetch: $setup.allTenantsQuery.refetch
                }, null, 8, ["model-value", "placeholder", "onRefetch"]),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        ($setup.tenants)
                            ? (_openBlock(), _createBlock($setup["Grid"], {
                                key: 0,
                                "data-cy": "tenant-list",
                                access: $props.access,
                                columns: $setup.gridColumns,
                                data: $setup.gridData,
                                "filter-key": $setup.searchQuery,
                                onEdit: _cache[1] || (_cache[1] = ($event) => ($setup.editTenant?.showEditTenant($event)))
                            }, null, 8, ["access", "columns", "data", "filter-key"]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]),
            _: 1
        })
    ]));
}
